export const asArray = (value) => {
    if (Array.isArray(value)) return value;
    if (Array.isArray(value?.content)) return value.content;
    if (Array.isArray(value?.data)) return value.data;
    return [];
};

export const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleDateString("fr-FR");
};

export const formatDateTimeInput = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16);
};

const toDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const isCurrentYearActiveCampaign = (campaign) => {
    const today = new Date();
    const year = Number(campaign?.anneeCampagne);
    if (year !== today.getFullYear()) return false;
    return isActiveCampaign(campaign);
};

export const isActiveCampaign = (campaign) => {
    const today = new Date();

    const start = toDate(campaign?.dateDebut);
    const end = toDate(campaign?.dateFin);
    if (start && today < start) return false;
    if (end) {
        const endOfDay = new Date(end);
        endOfDay.setHours(23, 59, 59, 999);
        if (today > endOfDay) return false;
    }
    return true;
};

export const sortCampaignsByDefault = (campaigns) => [...asArray(campaigns)].sort((a, b) => {
    const activeDiff = Number(isCurrentYearActiveCampaign(b)) - Number(isCurrentYearActiveCampaign(a));
    if (activeDiff !== 0) return activeDiff;

    const anyActiveDiff = Number(isActiveCampaign(b)) - Number(isActiveCampaign(a));
    if (anyActiveDiff !== 0) return anyActiveDiff;

    const yearDiff = Number(b?.anneeCampagne || 0) - Number(a?.anneeCampagne || 0);
    if (yearDiff !== 0) return yearDiff;

    return Number(b?.campagneId || b?.id || 0) - Number(a?.campagneId || a?.id || 0);
});

export const filterCampaignsWithDefaultFallback = (campaigns) => {
    const sorted = sortCampaignsByDefault(campaigns);
    const currentYearActive = sorted.filter(isCurrentYearActiveCampaign);
    if (currentYearActive.length > 0) return currentYearActive;

    const active = sorted.filter(isActiveCampaign);
    if (active.length > 0) return active;

    return sorted;
};

export const stepLabels = {
    OBJECTIFS_N_MOINS_1: "Objectifs N-1",
    COMPETENCES_GENERIQUES: "Compétences génériques",
    COMPETENCES_SPECIFIQUES: "Compétences spécifiques",
    PLAN_DEVELOPPEMENT: "Plan de développement",
    OBJECTIFS_N: "Objectifs N",
    ENTRETIEN_ANNUEL: "Entretien annuel",
};

export const actionLabel = (action, hasProgress, status, progression) => {
    if (["COMPLETED", "TERMINEE", "TERMINE", "VALIDATED", "APPROVED"].includes(status) || Number(progression) >= 100) return "Consulter";
    if (action === "CONSULTER") return "Consulter";
    if (action === "PENDING_VALIDATION" || status === "PENDING_VALIDATION") return "En attente de validation";
    if (status === "IN_PROGRESS") return "Reprendre";
    if (action === "REPRENDRE") return "Reprendre";
    if (action === "COMMENCER" || status === "NOT_STARTED") return "Commencer";
    if (hasProgress) return "Reprendre";
    return "Commencer";
};

export const statusTone = (status) => {
    if (["COMPLETED", "TERMINEE", "TERMINE", "VALIDATED", "APPROVED"].includes(status)) return "green";
    if (["BLOCKED", "REJECTED", "CANCELLED", "ANNULE", "ERROR"].includes(status)) return "red";
    return "blue";
};

export const StepState = ({ loading, error, empty, children }) => {
    if (loading) return (
        <div className="perf-state">
            <span style={{ display: "inline-block", width: 14, height: 14, border: "2px solid #e5e7eb", borderTopColor: "#ef4444", borderRadius: "50%", animation: "perf-spin .7s linear infinite", flexShrink: 0 }} />
            Chargement...
        </div>
    );
    if (error) return <div className="perf-state perf-state--error">⚠ {error}</div>;
    if (empty) return <div className="perf-state">Aucune donnée disponible.</div>;
    return children;
};

export const Field = ({ label, children }) => (
    <label className="perf-field">
        <span>{label}</span>
        {children}
    </label>
);

export const formatStatus = (status) => {
    const labels = {
        NOT_STARTED:  "Non démarré",
        IN_PROGRESS:  "En cours",
        COMPLETED:    "Terminé",
        PENDING_VALIDATION: "En attente de validation",
        PENDING:      "En attente",
        VALIDATED:    "Validé",
        REJECTED:     "Rejeté",
        CANCELLED:    "Annulé",
    };
    if (!status) return "-";
    return labels[status] ?? status.replace(/_/g, " ");
};
